import filemanagerGetApi from '../../../api/filemanagerGetApi';

/**
 * Context menu actions
 * {name}Action
 */
export default {
  methods: {
    /**
     * Open folder
     */
    openAction() {
      // select directory
      this.$store.dispatch(`${this.$store.state.activeManager}/selectDirectory`, {
        path: this.selectedItems[0].path,
        history: true,
      });
    },

    workflowAction() {
      // initiate workflow process
      this.$store.commit('modal/setModalState', {
        modalName: 'Workflow',
        show: true,
      });
    },

    /**
     * Play music or video
     */
    audioPlayAction() {
      // show player modal
      this.$store.commit('modal/setModalState', {
        modalName: 'DocumentPreview',
        show: true,
      });
    },

    /**
     * Play music or video
     */
    videoPlayAction() {
      // show player modal
      this.$store.commit('modal/setModalState', {
        modalName: 'DocumentPreview',
        show: true,
      });
    },

    /**
     * View file
     */
    viewAction() {
      // show image
      this.$store.commit('modal/setModalState', {
        modalName: 'DocumentPreview',
        show: true,
      });
    },

    /**
     * Edit file
     */
    editAction() {
      // show text file
      this.$store.commit('modal/setModalState', {
        modalName: 'TextEdit',
        show: true,
      });
    },

    /**
     * Edit file with Microsoft Office
     */
     editWithOfficeAction() {
      // TODO: open file with office
      const path = encodeURIComponent(this.selectedItems[0].path);
       const baseUrl = process.env.VUE_APP_DEFAULT_URL + "/file-manager/";
      const userId = JSON.parse(localStorage.getItem('user')).id;
      const fileLocation = `${baseUrl}office-edit/${userId}/${path}`;
      const extension = this.selectedItems[0].extension;
      switch (extension.toLowerCase()) {
        case 'docx':          
          window.location = `ms-word:ofe|u|${fileLocation}`;
          break;
        case 'xlsx':
          window.location = `ms-excel:ofe|u|${fileLocation}`;
          break;
        case 'pptx':
          window.location = `ms-powerpoint:ofe|u|${fileLocation}`;
          break;
      }
    },

    /**
     * Keep an old version of file and save in the new file
     */
    modifyAction(){
      this.$store.commit('modal/setModalState', {
        modalName: 'ModifyFile',
        show: true,
      });
    },
    
    modifyDocumentTypeAction(){
      this.$store.commit('modal/setModalState', {
        modalName: 'ModifyDocumentType',
        show: true,
      });
    },

    /**
     *  After a search we can open emplacement of file
     */
    fileLocationAction() {
      const filepath = this.selectedItems[0].path.split('/');
      const file = filepath.pop();
      const path = filepath;
      let fullPath = '';
      for (let i = 0; i < path.length; i++) {
         fullPath = fullPath + path[i]+"/";
      }
      // TODO: Preselect the item
      this.$store.dispatch(`${this.$store.state.activeManager}/selectDirectory`, {
        path: fullPath,
        history: true,
      });
      console.log(file);
    },

    /**
     * Select file
     */
    selectAction() {
      // file callback
      this.$store.dispatch('url', {
        disk: this.selectedDisk,
        path: this.selectedItems[0].path,
      }).then((response) => {
        if (response.data.result.status === 'success') {
          this.$store.state.fileCallback(response.data.url);
        }
      });
    },

    /**
     * Download file
     */
    downloadAction() {
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.setAttribute('download', this.selectedItems[0].basename);

      // download file with authorization
      if (this.$store.getters['settings/authHeader']) {
        filemanagerGetApi.download(this.selectedDisk, this.selectedItems[0].path).then((response) => {
          tempLink.href = window.URL.createObjectURL(new Blob([response.data]));
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
        });
      } else {
        tempLink.href = `${this.$store.getters['settings/baseUrl']}download?disk=${this.selectedDisk}&path=${encodeURIComponent(this.selectedItems[0].path)}`;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      }
    },

    /**
     * share selected item
     */
    shareAction() {
      this.$store.commit('modal/setModalState', {
        modalName: 'Share',
        show: true,
      });
    },

    /**
     * Copy selected items
     */
    copyAction() {
      // add selected items to the clipboard
      this.$store.dispatch('toClipboard', 'copy');
    },

    /**
     * Cut selected items
     */
    cutAction() {
      // add selected items to the clipboard
      this.$store.dispatch('toClipboard', 'cut');
    },

    /**
     * Rename selected item
     */
    renameAction() {
      // show modal - rename
      this.$store.commit('modal/setModalState', {
        modalName: 'Rename',
        show: true,
      });
    },

    /**
     * Paste copied or cut items
     */
    pasteAction() {
      // paste items in the selected folder
      this.$store.dispatch('paste');
    },

    /**
     * Zip selected files
     */
    zipAction() {
      // show modal - Zip
      this.$store.commit('modal/setModalState', {
        modalName: 'Zip',
        show: true,
      });
    },

    /**
     * Unzip selected archive
     */
    unzipAction() {
      // show modal - Unzip
      this.$store.commit('modal/setModalState', {
        modalName: 'Unzip',
        show: true,
      });
    },

    /**
     * Delete selected items
     */
    deleteAction() {
      // show modal - delete
      this.$store.commit('modal/setModalState', {
        modalName: 'Delete',
        show: true,
      });
    },

    /**
     * Show properties for selected items
     */
    propertiesAction() {
      // show modal - properties
      this.$store.commit('modal/setModalState', {
        modalName: 'Properties',
        show: true,
      });
    },
  },
};
